export const loanRoutes = {
	base: "loans",
	outstanding: "outstanding",
	closed: "closed",
};
